import React, { useEffect, useState, useRef } from "react";
import "../App.css";
import ScrollAnimation from "react-animate-on-scroll";
import { scroller } from "react-scroll";
import axios from "../axios";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Adhyayi Logo Tr.png";
import heroImage from "../Images/man-with-easel-before-screen-with-video-learning-how-draw-portrait-illustration.png";
import BannerDesign from "../Images/bannerDesignImage.png";
import heroImage3 from "../Images/hero.png";
import mobileImage from "../Images/mobile.png";
import AboutImamge from "../Images/about.png";
import bgImage from "../Images/Section (2).png";
import Correct from "../Images/Vector.png";
import Info from "../Images/ph_info-duotone.png";
import ReferShare from "../Images/referlink.png";
import Askfreind from "../Images/ask friend.png";
import EarnPoints from "../Images/eran points.png";
import Star from "../Images/Container.png";
import FactImage from "../Images/fact_img.png.png";
import QuamaImage from "../Images/quamaImage.png";
import Ratingstars from "../Images/ratingstar.png";
import Upcoming from "../Images/Categorey-Icon-7.svg.png";

import Button from "../componant/Button/Button";

import { FaArrowRightLong } from "react-icons/fa6";
import {
  Apple,
  Bank,
  BookOpen,
  Bot,
  ClipboardList,
  ChevronLeft,
  Clock3,
  Coins,
  Play,
  ShieldCheck,
  Signal,
  Star as StarIcon,
  Target,
  Train,
  Users,
  Wifi,
} from "lucide-react";

import CountUp from "react-countup";
import Slider from "react-slick";
import Contactus from "./Hompage/Contactus";
import HomeNavbar from "./Hompage/HomeNavbar";
import Footer from "./Hompage/Footer";
import UpcomingExam from "./Hompage/UpcomingExam";
import Contestpage from "./Hompage/Contestpage";
import ExploreCategories from "./Hompage/ExploreCategories";
import FaqsPage from "./Hompage/Faqs";
import HowItsWorks from "./Hompage/HowItsWorks";
import WhyChooseUs from "./Hompage/WhyChooseUs";
import Testimonials from "./Hompage/Testimonials";
import TopHeroMarquee from "./Dashboard/userPanal/Mcq/HeroCourseSlider";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "red" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "green" }}
      onClick={onClick}
    />
  );
}

function MobileAppPromoSection() {
  const topLearners = [
    { name: "Ritesh Sharma", coins: "89,400 Credits", score: "52,000" },
    { name: "Sneria Pari", coins: "33,800 Credits", score: "48,500" },
    { name: "Aman Kumar", coins: "48,200 Credits", score: "45,200" },
  ];

  const features = [
    { icon: Bot, text: "AI-Powered Study Support" },
    { icon: Clock3, text: "Daily GK & Contest Updates" },
    { icon: Coins, text: "Instant Credit Reward System" },
  ];

  return (
    <ScrollAnimation
      duration={3}
      animateIn="fadeIn"
      initiallyVisible={true}
      animateOnce={true}
      className="w-full"
    >
      <section className="w-full overflow-hidden bg-bgBlue py-3 font-poppins text-white sm:py-5">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-6 px-5 lg:flex-row lg:justify-between lg:gap-10 lg:px-10">
          <div className="hidden sm:block relative flex w-full justify-center lg:w-[42%]">
            <img
              src={mobileImage}
              alt="Mobile App"
              className="mx-auto max-w-[260px] rounded-[2rem] sm:max-w-[320px] lg:max-w-[360px]"
            />
          </div>

          <div className="w-full text-center lg:w-[58%] lg:text-left">
            <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:mx-0 lg:text-5xl">
              Start Learning. Start Earning - Anytime, Anywhere.
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/75 sm:text-xl lg:mx-0">
              Join thousands of learners who are already earning by studying
              smart on our mobile app!
            </p>

            <div className="hidden sm:block mx-auto mt-6 flex flex-row items-center gap-4 max-w-2xl lg:flex-col lg:items-start lg:mx-0">
              <div className="flex-1 space-y-3">
                {features.map(({ icon: Icon, text }) => (
                  <div
                    key={text}
                    className="flex items-center justify-center gap-2 text-base font-bold text-white sm:text-xl lg:justify-start"
                  >
                    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full border-2 border-secondary text-secondary">
                      <Icon size={20} strokeWidth={2.3} />
                    </span>
                    <span>{text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="
    mt-6
    flex
    items-center
    justify-between
    gap-4
    sm:flex-row
    lg:justify-start
  "
>
  {/* Mobile Image */}
 <div className="flex items-center gap-4">
  {/* Mobile Image - sirf mobile par */}
  <div className="w-[42%] flex justify-center sm:hidden">
    <img
      src={mobileImage}
      alt="Mobile App"
      className="w-full max-w-[180px] rounded-[1.5rem]"
    />
  </div>

  {/* Buttons */}
   <div className="flex  gap-4 justify-center items-center mt-2 sm:mt-6">
              <Button
                Text="Get Started"
                bgColor="secondary"
                textColor="white"
                Links="/login"
              />

<Button
  Text="Download Now"
  bgColor="black"
  textColor="white"
  Links="https://play.google.com/store/apps/details?id=com.adhyayi.app"
  icon={<Play size={20} fill="#20d15f" className="text-[#20d15f]" />}
/>     
       </div>
</div>
</div>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-5xl px-5 text-center text-sm text-white/80 sm:text-lg">
          Trusted by 50,000+ learners | 4.8+ Ratings | 100% Transparent Rewards
        </p>
      </section>
    </ScrollAnimation>
  );
}

const ratingStats = [
  {
    icon: Users,
    value: 4500,
    suffix: "K+",
    label: "Number of Users",
    iconClass: "text-white shadow-[0_18px_40px_rgba(125,60,255,0.34)]",
  },
  {
    icon: StarIcon,
    value: 4.6,
    suffix: "",
    label: "Star Rating",
    decimals: 1,
    iconClass: "text-[#f3dcff] shadow-[0_18px_40px_rgba(125,60,255,0.30)]",
  },
  {
    icon: ClipboardList,
    value: 328,
    suffix: "+",
    label: "Number Of Tests Taken",
    iconClass: "text-white shadow-[0_18px_40px_rgba(125,60,255,0.30)]",
  },
  {
    icon: Target,
    value: 80,
    suffix: "K+",
    label: "Questions Attempted",
    iconClass: "text-white shadow-[0_18px_40px_rgba(125,60,255,0.30)]",
  },
];

function Dashboard() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    // dots: true,
    accessibility: false,
    adaptiveHeight: true,
    // dots: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    // nextArrow: <SampleNextArrow/>,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // cssEase: "linear"
        },
      },
    ],
  };
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      axios.get("getAllCourses").then((response) => {
        if (response?.data) {
          setData(response?.data?.result);
          localStorage.setItem("plans", JSON.stringify(response?.data?.result));
        }
      });
    }
    fetchData();
  }, []);

  console.log(data);

  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);

  // Auto-scroll rating row on mobile
  const ratingRef = useRef(null);
  useEffect(() => {
    const el = ratingRef.current;
    if (!el) return;
    const isMobile = window.innerWidth < 1024;
    if (!isMobile) return;

    let rafId;
    const speed = 0.6; // pixels per frame

    const step = () => {
      if (!el) return;
      el.scrollLeft = Math.min(
        el.scrollLeft + speed,
        el.scrollWidth - el.clientWidth,
      );
      if (el.scrollLeft >= el.scrollWidth - el.clientWidth - 1) {
        // reset smoothly
        el.scrollLeft = 0;
      }
      rafId = requestAnimationFrame(step);
    };

    rafId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafId);
  }, []);

  // const [currentIndex, setCurrentIndex] = useState(0);
  // const cardsPerView = 4;
  // const totalCards = data.length;

  // const handlePrev = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex - 1 + totalCards) % totalCards);
  // };

  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % totalCards);
  // };

  //  const planss= JSON.parse(localStorage.getItem("plans"))
  //  console.log(planss)

  return (
    <div className="overflow-x-hidden">
      {/* <Navbar /> */}
      <HomeNavbar />

      <div className=" flex flex-col items-center justify-center mt-16">
        {/* Hero Section */}
        <div
          id="home"
          className="w-full py-10 flex flex-col lg:flex-row items-center m-auto font-poppins text-center gap-10 px-6"
          style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundSize: "cover",
          }}
        >
          <div className="hidden md:block hover:animate-bounce">
            <img
              src={BannerDesign}
              alt="Banner Design"
              className="transition-transform duration-500 ease-in-out transform hover:scale-105 hover:rotate-6"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <div className="flex flex-col items-center ">
              <h1 className="w-full text-center text-2xl lg:text-4xl font-bold font-oswald text-black">
                Prepare Smart.
                <span className="text-bgBlue"> Practice More.</span>
              </h1>

              <h1 className="w-full text-center text-2xl lg:text-4xl font-bold font-oswald text-secondary">
                Get Rewards.
              </h1>
            </div>
            <p className="text-md lg:text-lg text-bgBlue mt-4 sm:mb-6 animate-slide-in-left">
              Turn your daily exam preparation into an exciting learning journey
              with <span className="font-bold">Adhyayi</span> — featuring smart
              quizzes, live contests, rankings, rewards, and real-time
              performance tracking.
            </p>
            <div className="hidden lg:flex justify-center items-center space-x-4 gap-6 ">
              <Button
                Text="Get Started"
                bgColor="secondary"
                textColor="white"
                Links="/login"
              />
              <Link
                to="https://play.google.com/store/apps/details?id=com.adhyayi.app"
                className="
        flex
        h-12
        items-center
        justify-center
        rounded-full
        border
        border-white/80
        bg-black
        px-4
        text-white
        shadow-lg
        transition
        duration-300
        hover:-translate-y-1
        mt-2
       
      "
              >
                <Play size={24} fill="#20d15f" className="text-[#20d15f]" />

                <span className="text-left leading-none">
                  <span className="block text-[11px]">Download on</span>

                  <span className="block text-sm font-bold">Google Play</span>
                </span>
              </Link>
              {/* <Button Text="Download Now" bgColor="white" textColor="black" Links="https://play.google.com/store/apps/details?id=com.adhyayi.app"/> */}
            </div>
          </div>
          <div
            className={`lg:w-1/2 ${slideIn ? "animate-slide-in-right" : ""}`}
          >
            <img
              src={heroImage3}
              alt="Hero"
              className="lg:max-w-2xl sm:h-96 sm:mb-6 lg:m-auto transition-transform duration-500 ease-in-out transform hover:scale-105 hover:rotate-6"
            />
            <div className="flex lg:hidden flex  gap-8 justify-center items-center mt-2 sm:mt-6">
              <Button
                Text="Get Started"
                bgColor="secondary"
                textColor="white"
                Links="/login"
              />
              {/* <Button Text="DownLoad Now" bgColor="white" textColor="black" Links="https://play.google.com/store/apps/details?id=com.adhyayi.app"/> */}
              <Link
                to="https://play.google.com/store/apps/details?id=com.adhyayi.app"
                className="
        flex
        h-12
      
        items-center
        justify-center
        gap-3
        rounded-full
        border
        border-white/80
        bg-black
        px-4
        text-white
        shadow-lg
        transition
        duration-300
        hover:-translate-y-1
        mt-2
        
      "
              >
                <Play size={24} fill="#20d15f" className="text-[#20d15f]" />

                <span className="text-left leading-none">
                  <span className="block text-[11px]">Download on</span>

                  <span className="block text-sm font-bold">Google Play</span>
                </span>
              </Link>
            </div>
          </div>
        </div>

        <HowItsWorks />
        {/* <Howworks /> */}

        {/* Plans Section */}
        {/* <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        > */}
        <div
          id="plans"
          style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundSize: "cover",
            //  backgroundRepeat: 'no-repeat',
            //  backgroundPosition: 'center'
          }}
          className="bg-bgWhite w-full py-12 text-center font-poppins"
        >
          <div className=" flex items-center justify-center mb-4">
            <p
              style={{ backgroundColor: "#F5A623" }}
              className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
            >
              Top Class Courses
            </p>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4 animate-fade-in">
            Explore Our World's{" "}
            <span className="text-secondary">Best Courses </span>
          </h2>
          <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
            Unlock your dream government job with our expert-led courses!
            Explore our comprehensive and interactive learning programs,
            designed to help you crack the toughest government exams with ease.
            From UPSC Civil Services to SSC CGL, Banking, and Defence exams, our
            courses cover it all.
          </p>
          <ScrollAnimation
            duration={3}
            animateIn="flipInY"
            animateOnce={true}
            initiallyVisible={true}
            className="w-full"
          >
            <div class="mt-10 ">
              <TopHeroMarquee data={data} />
            </div>
          </ScrollAnimation>
        </div>
        {/* </ScrollAnimation> */}

        {/* Contest Page */}

        <Contestpage />
        <ExploreCategories />

        <WhyChooseUs />

        {/* //upcomimg exame/ */}
        {/* <ScrollAnimation initiallyVisible={true}
          animateOnce={true} duration={3} animateIn="fadeIn" className="w-full">
          <div
            id="upcoming"
            className="bg-white w-full py-12 text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#F5A623" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Trending
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              Upcoming <span className="text-secondary">Exams </span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
              Nullam eleifend metus ipsum, at ornare odio vehicula in.
              Pellentesque condimentum ntum vehicula.Nulla convallis enim eu
              velit commodo condimentum.
            </p>
            <br />
            <ScrollAnimation
              duration={3}
              animateIn="bounceInRight"
              animateOut="bounceOutLeft"
              initiallyVisible={true}
              animateOnce={true}
            >
              <div class="space-y-8 lg:w-3/4 w-full lg:grid lg:grid-cols-3 m-auto sm:gap-10 xl:gap-10 lg:space-y-0 p-4 lg:p-0">
                <div
                  style={{ backgroundColor: "#F1D9CC" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#F5A623" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl  h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>


                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#FFF7E2" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#F5A623" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

               
              </div>
            </ScrollAnimation>
            <br />
            
          </div>
        </ScrollAnimation> */}
        <UpcomingExam />

        <MobileAppPromoSection />

        {/* About us  */}

        <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <div
            id="about-us"
            className="w-full m-auto flex flex-col justify-center items-center mt-8 p-4"
          >
            <div className=" flex items-center justify-center lg:justify-start   ">
              <p
                style={{ backgroundColor: "#F5A623" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Get More About us
              </p>
            </div>
            <div className="lg:w-4/5  flex flex-col lg:flex-row items-center m-auto font-poppins text-center ">
              <div
                className={`lg:w-1/2 ${
                  slideIn ? "animate-slide-in-right" : ""
                } `}
              >
                <img
                  src={AboutImamge}
                  alt="About"
                  className=" lg:max-w-3xl w-96 m-auto lg:m-0 "
                />
              </div>
              <div className={`w-full lg:w-1/2 lg:text-start  p-2 lg:p-0`}>
                <br />

                <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
                  Empowering Students to reach their{" "}
                  <span className="text-secondary">potential</span> Goal For
                  Next Level Challenge.{" "}
                </h1>

                <p className="text-sm  text-bgBlue mb-6 animate-slide-in-left">
                  Empowering students to reach their potential involves
                  providing them with the tools, resources, and support needed
                  to overcome challenges and achieve their goals. By fostering a
                  growth mindset, offering personalized learning experiences,
                  and encouraging perseverance, students can be prepared to
                  tackle the next level of their educational and professional
                  journeys. This holistic approach not only boosts their
                  confidence but also equips them with the skills necessary for
                  lifelong success.{" "}
                </p>
                <div className="mt-6">
                  <Link to={"/login"}>
                    <div className="w-44 flex m-auto lg:m-0 py-2.5 justify-center items-center gap-4 rounded-full bg-secondary text-white shadow-[6px_6px_#4B2C72] transition duration-300">
                      <button>Start Free Trial</button>
                      <FaArrowRightLong />
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* rating section */}
            <div className="w-full bg-white px-4 pt-4 lg:px-0">
              <div className="relative mx-auto w-full overflow-hidden rounded-[2rem] bg-[linear-gradient(135deg,#4B2C72_0%,#5A3688_45%,#6A429D_100%)] px-5 py-6 shadow-[0_28px_70px_rgba(77,33,157,0.24)] lg:w-4/5 lg:rounded-[2.3rem] lg:px-8">
                <div className="absolute -left-8 bottom-0 h-28 w-28 rounded-full border border-white/10" />
                <div className="absolute -left-3 bottom-2 h-20 w-20 rounded-full border border-white/10" />
                <div className="absolute left-6 top-10 grid grid-cols-4 gap-2 opacity-30">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <span
                      key={`left-dot-${index}`}
                      className="h-1.5 w-1.5 rounded-full bg-[#b98cff]"
                    />
                  ))}
                </div>
                <div className="absolute right-6 top-8 grid grid-cols-4 gap-2 opacity-40">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <span
                      key={`right-dot-${index}`}
                      className="h-1.5 w-1.5 rounded-full bg-[#b98cff]"
                    />
                  ))}
                </div>

                <div
                  className="relative z-10 overflow-x-auto scroll-smooth"
                  ref={ratingRef}
                >
                  <div className="flex gap-4 min-w-max lg:grid lg:grid-cols-4 lg:gap-0">
                    {ratingStats.map(
                      (
                        {
                          icon: Icon,
                          value,
                          suffix,
                          label,
                          decimals,
                          iconClass,
                        },
                        index,
                      ) => (
                        <div
                          key={label}
                          className={`flex-shrink-0 min-w-[180px] lg:flex-1 lg:min-w-0 flex flex-col items-center text-center px-2 py-2 ${
                            index !== ratingStats.length - 1
                              ? "lg:border-r lg:border-white/20"
                              : ""
                          }`}
                        >
                          <div
                            className={`flex h-14 w-14 items-center justify-center rounded-full border border-white/10 bg-bgBlue ${iconClass}`}
                          >
                            <Icon
                              size={30}
                              className={
                                label === "Star Rating" ? "fill-current" : ""
                              }
                              strokeWidth={1.8}
                            />
                          </div>

                          <p className="mt-3 text-xl font-extrabold tracking-tight text-white lg:text-3xl">
                            <CountUp
                              end={value}
                              duration={2}
                              decimals={decimals || 0}
                            />
                            {suffix}
                          </p>
                          <span className="mt-2 h-1 w-16 rounded-full bg-[linear-gradient(135deg,#4B2C72_0%,#6D42A8_50%,#8B5CF6_100%)]" />
                          <p className="mt-2 text-xs font-medium text-white/85 lg:text-base">
                            {label}
                          </p>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollAnimation>

        {/* refer & ern */}
        <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <div
            id="refer-earn"
            className="bg-white w-full py-12 px-4 text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#F5A623" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Refer & Earn
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              Refer Your Friends And{" "}
              <span className="text-secondary">Earn Learn Points </span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
              Share the power of learning with your friends and earn rewards!
              Start sharing your referral link now and earn points to unlock
              exciting rewards!"
            </p>
            <br />
            <ScrollAnimation
              duration={3}
              animateIn="bounceInRight"
              animateOut="bounceOutLeft"
              initiallyVisible={true}
              animateOnce={true}
            >
              <div class="space-y-8 lg:w-4/5 w-full lg:grid lg:grid-cols-3 m-auto sm:gap-10 xl:gap-10 lg:space-y-0 p-4 lg:p-0 ">
                <div
                  style={{ backgroundColor: "#F1D9CC" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-4 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex   justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={ReferShare} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue ">
                        Share Your Refer Link
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    Redeem your points for exciting rewards, including discounts
                    on courses, exclusive access to expert sessions, free trial
                    classes, and more!
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F5A623" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-6 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex  justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={Askfreind} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue ">
                        Ask to Friend Buy Course
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    By inviting your friends to join our courses, you'll not
                    only help them grow but also earn points for yourself. Start
                    asking your friends to buy courses today
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-6 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex  justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={EarnPoints} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue">
                        Earn Reward Points
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    Our referral program is designed to thank you for spreading
                    the word about our courses. With every referral, you'll not
                    only earn points but also help your friends unlock
                    their potential.
                  </span>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </ScrollAnimation>

        {/* <WhyChooseUs /> */}

        {/* FAQS Section */}

        <FaqsPage />

        {/* Testimonials Section */}

        <Testimonials />

        {/* Contact Section */}
        <ScrollAnimation
          duration={4}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <Contactus />
        </ScrollAnimation>

        {/* Footer Section */}

        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default Dashboard;
